import React from "react";

type ViewIconProps = React.SVGProps<SVGSVGElement> & { color?: string };

export const ViewIcon = ({ width = 24, height = 24, color = "#79808A", ...props }: ViewIconProps) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M19.6352 11.2364C19.8784 11.5772 20 11.7484 20 12.0004C20 12.2532 19.8784 12.4236 19.6352 12.7644C18.5424 14.2972 15.7512 17.6004 12 17.6004C8.24799 17.6004 5.4576 14.2964 4.3648 12.7644C4.1216 12.4236 4 12.2524 4 12.0004C4 11.7476 4.1216 11.5772 4.3648 11.2364C5.4576 9.70358 8.24879 6.40039 12 6.40039C15.752 6.40039 18.5424 9.70438 19.6352 11.2364Z" stroke="#79808A" stroke-width="1.5"/>
<path d="M14.4 11.9996C14.4 11.3631 14.1471 10.7526 13.697 10.3026C13.2469 9.85246 12.6365 9.59961 12 9.59961C11.3635 9.59961 10.753 9.85246 10.3029 10.3026C9.85283 10.7526 9.59998 11.3631 9.59998 11.9996C9.59998 12.6361 9.85283 13.2466 10.3029 13.6967C10.753 14.1467 11.3635 14.3996 12 14.3996C12.6365 14.3996 13.2469 14.1467 13.697 13.6967C14.1471 13.2466 14.4 12.6361 14.4 11.9996Z" stroke="#79808A" stroke-width="1.5"/>
</svg>

);

export default ViewIcon;
